import { Component, Input, OnInit } from '@angular/core';
import { PortalSubscriptions } from '../../_models/portal/portal-subscriptions.model';
import { MenuItem } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { SubscriptionsUpdateDialogComponent } from 'src/app/features/portal-management/components/subscriptions/subscriptions-update-dialog/subscriptions-update-dialog.component';
import { map, Observable } from 'rxjs';
import { UserService } from 'src/app/_share/_services/user.service';
import { ConfirmationService } from 'primeng/api';
import { PortalSubscriptionService } from 'src/app/features/portal/_services/portal/portal-subscription.service';
import { NotificationService } from '../../_services/notification.service';
import { PortalManagementSubscriptionService } from 'src/app/features/portal/_services/management/portal-management-subscription.service';
import { CancelSubscriptionDialogComponent } from 'src/app/features/portal-management/components/subscriptions/cancel-subscription-dialog/cancel-subscription-dialog.component';
import { PortalManagementBillingService } from 'src/app/features/portal/_services/management/portal-management-billing.service';
import { AgentCommissionDialogComponent } from 'src/app/features/portal-management/components/agent-commission-dialog/agent-commission-dialog.component';
import { SubscriptionsUpgradeDialogComponent } from 'src/app/features/portal-management/components/subscriptions/subscriptions-upgrade-dialog/subscriptions-upgrade-dialog.component';
import { ClaimCircuitDialogComponent } from 'src/app/features/portal-management/components/subscriptions/claim-circuit-dialog/claim-circuit-dialog.component';
import { ChangeAccountReferenceDialogComponent } from 'src/app/features/portal-management/components/subscriptions/change-account-reference-dialog/change-account-reference-dialog.component';

@Component({
  selector: 'share-subscription-action-bar',
  templateUrl: './share-subscription-action-bar.component.html',
  styleUrls: ['./share-subscription-action-bar.component.scss']
})
export class ShareSubscriptionActionBarComponent implements OnInit {
  @Input() subscription: PortalSubscriptions | undefined;
  currentUser$: Observable<any> = this.us.currentUser$;

  userRole: any;
  @Input() onRefresh!: () => void;

  subscriptionActions: MenuItem[] = [];

  loadingAnniversary: boolean = false;
  loadingActivation: boolean = false;
  loadingOverride: boolean = false;
  loadingStatement: boolean = false;
  loadingRegrade: boolean = false;
  loadingRemoveRecurringPayment!: boolean;
  loadingManualBill: boolean = false;
  loadingSuspend: boolean = false;

  constructor(
    private pss: PortalSubscriptionService,
    private pmss: PortalManagementSubscriptionService,
    public ns: NotificationService,
    private ds: DialogService,
    private us: UserService,
    public confirmationService: ConfirmationService,
    private pmbs: PortalManagementBillingService
  ) {}

  ngOnInit(): void {
    this.currentUser$
      .pipe(
        map((user) => {
          this.userRole = user?.role;
          return user;
        })
      )
      .subscribe();

    if (!this.subscription) {
      throw new Error('Subscription is required');
    } else {
      if (this.subscription.subscription_status === 'new_sales_lead') {
        this.subscriptionActions = [
          {
            label: 'Assign Subscription Package',
            icon: 'pi pi-plus',
            styleClass: 'p-button-success',
            routerLink: ['/subscriptions', this.subscription?.id]
          },
          {
            label: 'Edit Subscription Details',
            icon: 'pi pi-pencil',
            styleClass: 'p-button-success',
            routerLink: ['/subscriptions', this.subscription?.id, 'edit']
          }
          // {
          //   label:
          // }
        ];
      }
      // if (this.subscription.subscription_status === 'active')
      else {
        this.subscriptionActions = [
          {
            label: 'Update Subscription Billing Date',
            icon: 'pi pi-calendar-plus',
            styleClass: 'p-button-success',

            // routerLink: ['/subscriptions', this.subscription?.id],
            command: (event) => {
              this.showUpdateSubscriptionDialog(this.subscription, event);
            }
          }
          // {
          //   label: 'Upgrade Subscription',
          //   icon: 'pi pi-pencil',
          //   styleClass: 'p-button-danger',
          //   routerLink: ['/subscriptions', this.subscription?.id, 'edit'],
          // },
          // {
          //   label: 'Cancel Subscription',
          //   icon: 'pi pi-times',
          //   styleClass: 'p-button-warning',
          //   routerLink: ['/subscriptions', this.subscription?.id, 'edit'],
          // },
          // {
          //   label: 'Edit Subscription Details',
          //   icon: 'pi pi-pencil',
          //   styleClass: 'p-button-success',
          //   routerLink: ['/subscriptions', this.subscription?.id, 'edit'],
          //   command: (event) => {
          //     console.log(event);
          //   },
          // },
        ];
      }
    }
  }

  showUpdateSubscriptionDialog(rowData: any, event: Event) {
    // Check if the target of the click event was the ellipsis button

    const ref = this.ds.open(SubscriptionsUpdateDialogComponent, {
      data: {
        subscription: rowData
      },
      modal: true,
      showHeader: true,
      header: 'Update Subscription Billing Date',
      width: '60%'
    });

    ref.onClose.subscribe((res) => {
      console.log('Dialog closed', res);
      this.onRefresh();
      // this.retrievePortalSubscriptions();
    });
  }

  showCancelRequestDialog(rowData: any, $event: Event) {
    console.log('Cancel Subscription Dialog');
    const ref = this.ds.open(CancelSubscriptionDialogComponent, {
      data: {
        subscriptionId: rowData.id
      },
      modal: true,
      showHeader: false,
      width: '75%'
    });

    ref.onClose.subscribe((res) => {
      console.log('Dialog closed', res);
      if (res && res.success) {
        this.ns.mainSuccess('Subscription cancelled successfully');
        this.onRefresh();
      } else if (res && !res.success) {
        this.ns.mainError('Failed to cancel subscription: ' + res.error);
      }
    });
  }

  showRegradeSubscriptionDialog(rowData: any, $event: Event) {
    console.log('Regrade Subscription Dialog');
    this.loadingRegrade = true;
    const ref = this.ds.open(SubscriptionsUpgradeDialogComponent, {
      data: {
        subscription: rowData
      },
      modal: true,
      showHeader: true,
      header: 'Regrade Subscription',
      width: '60%'
    });

    ref.onClose.subscribe((res) => {
      console.log('Dialog closed', res);
      if (!res) {
        this.loadingRegrade = false;
        return;
      }
      this.pmss
        .upgradePortalSubscription(
          res.subscription_id,
          res.upgrade_product_id,
          res.apply_immediately
        )
        .subscribe(
          (res) => {
            console.log('upgradePortalSubscription', res);
            this.ns.mainSuccess('Subscription regrade successfully requested');
            this.onRefresh();
            this.loadingRegrade = false;
          },
          (error) => {
            console.log('error', error);
            this.ns.mainError('Failed to regrade subscription ' + error);
            this.loadingRegrade = false;
          }
        );
    });
  }

  showClaimCircuitDialog(rowData: any, $event: Event) {
    const ref = this.ds.open(ClaimCircuitDialogComponent, {
      data: {
        subscription: rowData
      },
      modal: true,
      showHeader: true,
      header: 'Claim Circuit',
      width: '50%'
    });

    ref.onClose.subscribe((res) => {
      if (res?.success) {
        const activated = !!res.data?.subscription_activated;
        this.ns.mainSuccess(
          activated
            ? 'Circuit claimed and subscription activated successfully.'
            : 'Circuit claimed successfully.'
        );
        this.onRefresh();
      }
    });
  }

  showChangeAccountReferenceDialog(rowData: any, $event: Event) {
    const ref = this.ds.open(ChangeAccountReferenceDialogComponent, {
      data: {
        subscription: rowData
      },
      modal: true,
      showHeader: true,
      header: 'Change Account Reference',
      width: '50%'
    });

    ref.onClose.subscribe((res) => {
      if (res?.success) {
        this.ns.mainSuccess(
          `Account reference changed to ${res.data?.subscription_account_reference}.`
        );
        this.onRefresh();
      }
    });
  }

  showRequestReactivateSubscriptionDialog(rowData: any, $event: Event) {
    this.loadingActivation = true;
    this.confirmationService.confirm({
      message: 'Are you sure you want to reactivate this subscription?',
      header: 'Request Reactivate Subscription',
      icon: 'pi pi-info-circle',
      key: 'reactivate',
      accept: () => {
        this.pmss.requestSubscriptionReactivate(rowData.id, {}).subscribe({
          next: (res: any) => {
            console.log('Subscription reactivated successfully:', res);
            this.ns.mainSuccess('Subscription reactivated successfully');
            this.loadingActivation = false;
          },
          error: (err: any) => {
            console.error('Error reactivating subscription:', err);
            this.ns.mainError('Error reactivating subscription: ' + err.message);
            this.loadingActivation = false;
          }
        });
      }
    });
  }

  showRequestOverrideSubscriptionDialog(rowData: any, $event: Event) {
    console.log('Request Override Dialog', rowData);
    this.loadingOverride = true;

    this.confirmationService.confirm({
      message: 'Are you sure you want to request override for this subscription?',
      header: 'Request Override Subscription',
      icon: 'pi pi-info-circle',
      key: 'override',
      accept: () => {
        this.pmss.requestSubscriptionOverride(rowData.id, {}).subscribe({
          next: (res: any) => {
            console.log('Request override subscription successful:', res);
            this.ns.mainSuccess('Subscription overridden successfully');
            this.loadingOverride = false;
          },
          error: (err: any) => {
            console.error('Error requesting override subscription:', err);
            this.ns.mainError('Error requesting override subscription: ' + err.message);
            this.loadingOverride = false;
          }
        });
      }
    });
  }

  showSuspendSubscriptionDialog(rowData: any, $event: Event) {
    this.loadingSuspend = true;

    this.confirmationService.confirm({
      message: `Suspend subscription "${rowData.subscription_reference}" for non-payment? This immediately deactivates the customer's service.`,
      header: 'Suspend Subscription',
      icon: 'pi pi-exclamation-triangle',
      key: 'suspend',
      accept: () => {
        this.pmss.suspendSubscription(rowData.id).subscribe({
          next: (res: any) => {
            if (res?.success === false) {
              this.ns.mainError(res?.message || 'Failed to suspend subscription');
            } else {
              this.ns.mainSuccess(res?.message || 'Subscription suspended successfully');
            }
            this.loadingSuspend = false;
            this.onRefresh?.();
          },
          error: (err: any) => {
            console.error('Error suspending subscription:', err);
            this.ns.mainError(err?.error?.detail || 'Error suspending subscription: ' + err.message);
            this.loadingSuspend = false;
          }
        });
      },
      reject: () => {
        this.loadingSuspend = false;
      }
    });
  }

  manualBillSubscription(portalSubscription: PortalSubscriptions | undefined) {
    if (!portalSubscription) {
      this.ns.mainError('Invalid subscription');
      return;
    }
    this.loadingManualBill = true;
    this.pmbs.createManualBilling(portalSubscription.subscription_account_reference, {}).subscribe({
      next: (res: any) => {
        console.log('Manual billing created successfully:', res);
        this.ns.mainSuccess('Manual billing created successfully');
        this.loadingManualBill = false;
      },
      error: (err: any) => {
        console.error('Error creating manual billing:', err);
        this.ns.mainError('Error creating manual billing: ' + err.message);
        this.loadingManualBill = false;
      }
    });
  }

  downloadSubscriptionStatement(subscription: any) {
    console.log('Downloading subscription statement for:', subscription.id);
    this.loadingStatement = true;

    this.pmss.downloadSubscriptionStatement(subscription.id).subscribe({
      next: (res: any) => {
        try {
          // Access the response body since the API service returns the full HTTP response
          const blob = new Blob([res.body], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `subscription_statement_${subscription.id}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url); // Clean up the URL object
          console.log('Subscription statement downloaded successfully');
          this.loadingStatement = false;
          this.ns.mainSuccess('Subscription statement downloaded successfully');
        } catch (error) {
          console.error('Error creating download link:', error);
          this.loadingStatement = false;
          this.ns.mainError('Error downloading subscription statement: ' + error);
        }
      },
      error: (err: any) => {
        console.error('Error downloading subscription statement:', err);
        this.loadingStatement = false;
        this.ns.mainError('Error downloading subscription statement: ' + err.message);
        // You could add a toast notification here for user feedback
      }
    });
  }
  removeRecurringPayment(subscription: any) {
    this.pmss.removeRecurringPayment(subscription.id).subscribe({
      next: (res: any) => {
        console.log('Recurring payment removed successfully:', res);
        this.ns.mainSuccess('Recurring payment removed successfully');
        this.onRefresh();
        this.loadingRemoveRecurringPayment = false;
      },
      error: (err: any) => {
        console.error('Error removing recurring payment:', err);
        this.ns.mainError('Error removing recurring payment: ' + err.message);
        this.loadingRemoveRecurringPayment = false;
      }
    });
  }

  openAgentCommissionDialog(subscription: any) {
    const ref = this.ds.open(AgentCommissionDialogComponent, {
      data: {
        subscription: subscription
      },
      modal: true,
      showHeader: false,
      width: '50%'
    });

    ref.onClose.subscribe((res) => {
      console.log('Dialog closed', res);
      if (res) {
        this.ns.mainSuccess('Agent commission processed successfully');
      } else {
        this.ns.mainError('Failed to process agent commission');
      }
      // You can refresh the subscription details here if needed
    });
  }
}
